var render, staticRenderFns
import script from "./BindsListItem.vue?vue&type=script&lang=js&"
export * from "./BindsListItem.vue?vue&type=script&lang=js&"
import style0 from "./BindsListItem.vue?vue&type=style&index=0&id=0a1bad14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports